/**
 * What opens an edit popup, split from the provider that renders it (a module that exports both
 * a component and a hook defeats fast refresh — same split as `captureTierContext.ts`).
 */

import { createContext, useContext } from "react";

export type EditPopups = {
  /** Open the full task editor over the current screen, for a task known only by its id. */
  openTask: (id: string) => void;
  openNote: (id: string) => void;
  /** A project or Context entry the AI filed (D222), in a smaller popup of its own. */
  openProject: (id: string) => void;
  openContext: (id: string) => void;
};

// Outside a provider (a card rendered alone in a test) opening is a no-op, not a crash.
const NONE: EditPopups = {
  openTask: () => {},
  openNote: () => {},
  openProject: () => {},
  openContext: () => {},
};

export const EditPopupContext = createContext<EditPopups>(NONE);

export function useEditPopups(): EditPopups {
  return useContext(EditPopupContext);
}

/** Opens whatever the AI filed something as, in its edit popup (D222). */
export function openFiled(popups: EditPopups, kind: string, id: string): void {
  if (kind === "task") popups.openTask(id);
  else if (kind === "note") popups.openNote(id);
  else if (kind === "project") popups.openProject(id);
  else if (kind === "context") popups.openContext(id);
}
